export default __webpack_public_path__ + "static/media/liquidcolor.13bea529.jpg";